import React from 'react'
import { 
  FormGroup, FormControl, ControlLabel
} from 'react-bootstrap'
import { keys } from 'lodash'

import * as Feather from "react-feather"

import MarkdownField from '../lib/MarkdownField.jsx'

const styles = {
  featherIconWrapper: {
    borderRadius: 3,
    height: 30,
    width: 30,
    marginLeft: 10,

    display: "inline-flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    justifyContent: "center",
    alignContent: "flex-start",
    alignItems: "center",

    backgroundColor: "rgba(239,150,55,.9)",
    color: "#fff",
    border: "1px solid #fff",
    maxWidth: "80%",
  }
}

const featherIconsList = keys(Feather).sort()

// used for first warning and last warning

const ProductWarning = ({
  label, sublabel, warning, onChange, style
}) => {

  const FirstWarningIcon = warning.icon && Feather[warning.icon]

  return (
    <div style={style || {}}>
      <MarkdownField 
        onChange={text => onChange({ ...warning, text })}
        value={warning.text}
        label={label}
        sublabel={sublabel}
      />

      <FormGroup>
        <ControlLabel>Icono <small>(opcional)</small>: </ControlLabel>
        <FormControl
          style={{ marginLeft: 5 }}
          componentClass="select"
          value={warning.icon || "NULL"}
          onChange={evt => {
            console.log(evt)
            console.log(evt.target.value)
            onChange({
              ...warning, 
              icon: evt.target.value == "NULL" ? "" : evt.target.value
            })
          }}
        >
          <option value="NULL">Sin icono</option>
          <option value="AlertTriangle">AlertTriangle</option>
          <option value="Award">Award</option>
          <option value="Package">Package</option>
          <option value="Navigation">Navigation</option>
          <option value="Printer">Printer</option>
          <option disabled>---------------------</option>
          {
            featherIconsList.map(icon => (
              <option key={icon} value={icon}>{icon}</option>
            ))
          }
        </FormControl>
        <div style={styles.featherIconWrapper}>
          { FirstWarningIcon && <FirstWarningIcon /> }
        </div>
      </FormGroup>

      <FormGroup style={{marginLeft: 20}}>
        <ControlLabel>Enlace <small>(opcional): </small></ControlLabel>
        <FormControl 
          style={{ marginLeft: 5 }}
          value={warning.link}
          onChange={evt => onChange({ ...warning, link: evt.target.value })}
        />
      </FormGroup>
    </div>
  )
}

export default ProductWarning
